<template>
<div :class="{
         'odr-g-size-s-m': dimensionsMode !== 'l',
         'odr-g-size-l': dimensionsMode === 'l',
         'odr-g-size-m': dimensionsMode === 'm',
         'odr-g-size-s': dimensionsMode === 's',
         'odr-g-size-xs': dimensionsMode === 'xs',
         'odr-g-widget-rtl': $root.appConfig.rtl
     }"
     style="height: 100% !important;">
    <slot/>
</div>
</template>

<script>
import { mapState } from 'vuex';
import { debounce } from '@/utils/debounce';

export default {
    mounted () {
        let tickScroll = true;
        let tickResize = true;
        let setDimensionsResize = () => {
            if (!tickResize) {
                return;
            }
            tickResize = false;
            window.requestAnimationFrame(() => {
                this.$store.dispatch('dimensions/SET_DIMENSIONS_RESIZE', { appConfig: this.$root.appConfig });
                tickResize = true;
            });
        };
        let setDimensionsScroll = () => {
            if (!tickScroll) {
                return;
            }
            tickScroll = false;
            window.requestAnimationFrame(() => {
                this.$store.dispatch('dimensions/SET_DIMENSIONS_SCROLL', { appConfig: this.$root.appConfig });
                tickScroll = true;
            });
        };

        window.addEventListener('resize', setDimensionsResize);
        window.addEventListener('scroll', setDimensionsScroll);
        this.$nextTick(() => { // awaits [data-odr-flow] to be mounted
            this.$store.commit('dimensions/SET_FLOW_ELEMENT', this.$root.$el.querySelector('[data-odr-flow]'));
            setDimensionsResize();
            setDimensionsScroll();
        });
    },
    computed: {
        ...mapState('dimensions', {
            dimensionsMode: 'mode',
            width: 'width',
        }),
    },
    watch: {
        width () {
            if (window.__odrBus) {
                debounce(() => { window.__odrBus.$emit('possible-resize'); }, 100);
            }
        },
    },
};
</script>
